module.exports = __webpack_public_path__ + "static/media/basicKit__power.cd2037e8.jpg";